import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectSessionList } from "@store/sessions/selectors";
import { checkSavedSessionHandler } from "@utils";

import { SessionsItem } from "@store/sessions/types";

const useCheckUnsavedNotes = () => {
  const sessionsList = useSelector(selectSessionList);

  const checkIfSavedHandler = useCallback(() => {
    if (!sessionsList.length) return true;

    const sessionsSavedStates = sessionsList.map((sessionItem: SessionsItem) =>
      checkSavedSessionHandler(sessionItem.sessionId)
    );
    const isSaved = !sessionsSavedStates.some((elem) => !elem);
    return isSaved;
  }, [sessionsList]);

  useEffect(() => {
    const leaveTabHandler = (e: BeforeUnloadEvent) => {
      if (checkIfSavedHandler()) return null;

      const confirmationMessage = "message";
      (e || window.event).returnValue = confirmationMessage;
      return confirmationMessage;
    };

    window.addEventListener("beforeunload", leaveTabHandler);
    return () => {
      window.removeEventListener("beforeunload", leaveTabHandler);
    };
  }, [checkIfSavedHandler]);
};

export default useCheckUnsavedNotes;
